import { RenderDrawObj } from "./RenderDrawObj.js";
import { MathUtil } from "../../../math/MathUtil.js";
import { Point3D } from "../../Point3D.js";
import { ConvertUtils } from "../../../convert/ConvertUtils.js";
import { ObjectUtils } from "../../../object/ObjectUtils.js";
const _RenderTransactionDrawObj = class _RenderTransactionDrawObj extends RenderDrawObj {
  constructor(x, y, z) {
    var __super = (...args) => {
      super(...args);
      this._calc = {};
      // private _beforeObj: Obj;
      this._transactionDoneSubscribers = [];
      return this;
    };
    if (x instanceof Point3D) {
      __super(x);
    } else if (typeof x === "object") {
      __super(x);
    } else {
      __super({ x, y, z });
    }
    this._currentTransactionControlConfig = this.makeTransactionControlConfig({ targetPoint: { obj: this }, drawFps: 1 });
  }
  // get beforeObj() {
  //   return this._beforeObj;
  // }
  get calc() {
    return this._calc;
  }
  getCalc(key) {
    return this._calc[key];
  }
  setCalc(key, value) {
    this._calc[key] = value;
  }
  getTransactionStartPoint() {
    return this._currentTransactionControlConfig.transactionStartPoint;
  }
  getTransactionFrames() {
    return { points: this._currentTransactionControlConfig.points, calcs: this._currentTransactionControlConfig.calcs };
  }
  setTransactionIndex(index) {
    this._currentTransactionControlConfig.pointPositionIndex = index;
  }
  getTransactionIndex() {
    return this._currentTransactionControlConfig.pointPositionIndex;
  }
  getTransactionIndexRate() {
    return MathUtil.getPercentByTotal(this._currentTransactionControlConfig.points.length, this._currentTransactionControlConfig.pointPositionIndex + 1) / 100;
  }
  getCurrentTransactionPoint() {
    return this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex];
  }
  getCurrentDrawFps() {
    return this._currentTransactionControlConfig.config.drawFps;
  }
  getCurrentTransactionTargetPoint() {
    const drawFps = this.getCurrentDrawFps();
    const targetPoints = !Array.isArray(this._currentTransactionControlConfig.config.targetPoint) ? [this._currentTransactionControlConfig.config.targetPoint] : this._currentTransactionControlConfig.config.targetPoint;
    const size = Math.ceil(drawFps / targetPoints.length);
    const s = this._currentTransactionControlConfig.pointPositionIndex / size;
    return targetPoints[s];
  }
  remainingFrameCountTransaction() {
    return this._currentTransactionControlConfig.points.length - 1 - this._currentTransactionControlConfig.pointPositionIndex;
  }
  isDoneTransaction() {
    return this._currentTransactionControlConfig.pointPositionIndex >= this._currentTransactionControlConfig.points.length - 1;
  }
  makeTransactionControlConfig(transactionConfig) {
    if (transactionConfig.startPoint) {
      this.updateObjWithDefaults(transactionConfig.startPoint);
    }
    const transactionStartCalc = ObjectUtils.deepCopy(this._calc);
    if (transactionConfig.startCalcs) {
      Object.entries(transactionConfig.startCalcs).forEach(([k, v]) => {
        transactionStartCalc[k] = v;
      });
    }
    const requiredConfig = this.defaultTransactionConfig(transactionConfig);
    const targetPoints = requiredConfig.targetPoint = Array.isArray(requiredConfig.targetPoint) ? requiredConfig.targetPoint : [requiredConfig.targetPoint];
    const points = [];
    const currentPoint = this.copyObj();
    let startPoint = { obj: currentPoint, bezierConfig: _RenderTransactionDrawObj.DEFAULT_BEZIER };
    const drawFps = requiredConfig.drawFps;
    const size = Math.ceil(drawFps / targetPoints.length);
    for (let i = 0; i < targetPoints.length; i++) {
      const targetPoint = targetPoints[i];
      const point = MathUtil.cubicBezier({ start: startPoint.obj, end: targetPoint.obj }, { frame: size }, targetPoint.bezierConfig ?? _RenderTransactionDrawObj.DEFAULT_BEZIER);
      const setPoints = [startPoint.obj, ...point, targetPoint.obj];
      setPoints.forEach((it) => it.data = targetPoint.obj.data);
      points.push(...setPoints);
      startPoint = targetPoint;
    }
    if (drawFps <= 0 && targetPoints.length > 0) {
      const lastPoint = targetPoints[targetPoints.length - 1].obj;
      points.length = 0;
      points.push(lastPoint);
      this.updateObjWithDefaults(lastPoint);
    }
    const calcs = {};
    Object.entries(requiredConfig.calcs ?? {})?.forEach(([key, value], index) => {
      const values = Array.isArray(value) ? value : [value];
      let startPoint2 = transactionStartCalc[key];
      const points2 = [];
      for (let i = 0; i < values.length; i++) {
        const end = values[i];
        if (Array.isArray(end.value)) {
          const point = [];
          const cstart = startPoint2 ?? [];
          const cend = end.value;
          const rpoints = cend.map((it, index2) => {
            const b = MathUtil.cubicBezier({ start: cstart[index2] ?? 0, end: cend[index2] ?? 0 }, { frame: size }, end.bezierConfig ?? _RenderTransactionDrawObj.DEFAULT_BEZIER);
            return b;
          });
          const ss = ConvertUtils.toArrayDirectionChange(rpoints);
          points2.push(cstart, ...ss, cend);
        } else {
          const cstart = startPoint2 ?? 0;
          const point = MathUtil.cubicBezier({ start: cstart, end: end.value }, { frame: size }, end.bezierConfig ?? _RenderTransactionDrawObj.DEFAULT_BEZIER);
          points2.push(cstart, ...point, end.value);
        }
        startPoint2 = end.value;
      }
      if (drawFps <= 0 && points2.length > 0) {
        transactionStartCalc[key] = points2[points2.length - 1];
      }
      calcs[key] = points2;
    });
    const transactionControlConfig = {
      points,
      calcs,
      pointPositionIndex: 0,
      transactionStartCalcs: transactionStartCalc,
      transactionStartPoint: currentPoint,
      config: requiredConfig
    };
    return transactionControlConfig;
  }
  // setPosition(position: {x:number, y:number, z: number}, config?:{deferTransaction?:boolean}) {
  //
  //
  // }
  transaction(transactionConfig) {
    if (this.syncSubLayer?.name === "normalBounce_template") {
    }
    if (this.isDoneTransaction() && transactionConfig.deferTransaction) {
      this._currentTransactionControlConfig = this.makeTransactionControlConfig(transactionConfig);
    } else if (transactionConfig.deferTransaction) {
      this._waitTransactionConfig = transactionConfig;
    } else {
      this._currentTransactionControlConfig = this.makeTransactionControlConfig(transactionConfig);
    }
  }
  defaultTransactionConfig(transactionConfig) {
    const requiredConfig = {
      ...transactionConfig,
      // targetPoint: targetPoint,
      animationIterationCount: transactionConfig.animationIterationCount ?? 1,
      animationDirection: transactionConfig.animationDirection ?? "normal"
      // fillMode: transactionConfig.fillMode ?? 'backwards',
    };
    return requiredConfig;
  }
  render(draw, config) {
    this.x = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.x ?? this.x;
    this.y = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.y ?? this.y;
    this.z = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.z ?? this.z;
    this.volume = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.volume ?? this.volume;
    this.mass = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.mass ?? this.mass;
    this.e = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.e ?? this.e;
    this.rotate = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.rotate ?? this.rotate;
    this.width = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.width ?? this.width;
    this.height = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.height ?? this.height;
    this.transform[0] = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.transform[0] ?? this.transform[0];
    this.transform[1] = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.transform[1] ?? this.transform[1];
    this.transform[2] = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.transform[2] ?? this.transform[2];
    this.transform[3] = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.transform[3] ?? this.transform[3];
    this.transform[4] = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.transform[4] ?? this.transform[4];
    this.transform[5] = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.transform[5] ?? this.transform[5];
    this.color.r = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.color?.r ?? this.color.r;
    this.color.g = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.color?.g ?? this.color.g;
    this.color.b = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.color?.b ?? this.color.b;
    this.color.a = this._currentTransactionControlConfig.points[this._currentTransactionControlConfig.pointPositionIndex]?.color?.a ?? this.color.a;
    Object.entries(this._currentTransactionControlConfig.calcs ?? {}).forEach(([key, value]) => {
      this._calc[key] = value[this._currentTransactionControlConfig.pointPositionIndex];
    });
    this._currentTransactionControlConfig.pointPositionIndex = Math.min(this._currentTransactionControlConfig.pointPositionIndex + 1, this._currentTransactionControlConfig.points.length - 1);
    super.render(draw, config);
    if (this.isDoneTransaction()) {
      const targetPoints = Array.isArray(this._currentTransactionControlConfig.config.targetPoint) ? [...this._currentTransactionControlConfig.config.targetPoint] : [this._currentTransactionControlConfig.config.targetPoint];
      const targetCalcs = {};
      Object.entries(this._currentTransactionControlConfig?.config?.calcs ?? {}).forEach(([k, v]) => targetCalcs[k] = Array.isArray(v) ? v : [v]);
      if (this._waitTransactionConfig && this._waitTransactionConfig.deferTransaction) {
        this.transaction(this._waitTransactionConfig);
        this._waitTransactionConfig = void 0;
        return;
      }
      let startPoint = this._currentTransactionControlConfig.config.startPoint;
      let startCalcs = this._currentTransactionControlConfig.transactionStartCalcs;
      if (this._currentTransactionControlConfig.config.animationDirection === "reverse") {
        if (targetPoints.length > 0) {
          const targetStartPoint = targetPoints.pop();
          targetPoints.reverse();
          if (startPoint)
            targetPoints.push({ obj: startPoint });
          Object.entries(targetCalcs).forEach(([k, v]) => {
            const targetCalc = v.pop();
            if (targetCalc) {
              v.reverse();
              v.push({ value: startCalcs[k] });
              startCalcs[k] = targetCalc.value;
            }
          });
          if (targetStartPoint)
            startPoint = targetStartPoint.obj;
        }
      }
      if (this._currentTransactionControlConfig.config.animationIterationCount === "infinite") {
        this.transaction({
          ...this._currentTransactionControlConfig.config,
          startPoint,
          targetPoint: targetPoints,
          startCalcs,
          calcs: targetCalcs
        });
      } else if (this._currentTransactionControlConfig.config.animationIterationCount > 1) {
        this.transaction({
          ...this._currentTransactionControlConfig.config,
          startPoint,
          targetPoint: targetPoints,
          startCalcs,
          calcs: targetCalcs,
          animationIterationCount: this._currentTransactionControlConfig.config.animationIterationCount - 1
        });
      }
    }
  }
  // constructor(canvas: HTMLCanvasElement, context: CanvasRenderingContext2D, public avaliablePlace: Rectangle = new Rectangle(new Point(0, 0), new Point(0, 0))) {
  //     super(canvas, context);
  // }
  // get centerPoint(): Point {
  //     return new Point();
  // }
};
_RenderTransactionDrawObj.DEFAULT_BEZIER = { p1x: 0.61, p1y: 1, p2x: 0.88, p2y: 1 };
let RenderTransactionDrawObj = _RenderTransactionDrawObj;
export {
  RenderTransactionDrawObj
};
//# sourceMappingURL=RenderTransactionDrawObj.js.map
